import styled from "styled-components";

export const ShareButton = styled.button`
	background: transparent;
	appearance: none;
	outline: none;
	padding: 10px;
	border: none;
`;
